import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import "../../index.css";
import landingimg from "../../Assets/LandingPage/Landing.svg";
import style from "./landing.module.css";
import Navbar from "../Navbar/Navbar";
import { BsArrowRight } from "react-icons/bs";
import UsImage1 from "../../Assets/LandingPage/UsImage1.svg";
import UsImage2 from "../../Assets/LandingPage/UsImage2.svg";
import UsImage3 from "../../Assets/LandingPage/UsImage3.svg";
import blobImage1 from "../../Assets/LandingPage/blobImage1.svg";
import blobImage2 from "../../Assets/LandingPage/blobImage2.svg";
import Login from "./Login/Login";
import Signup from "./Signup/Signup";

function Landingpage() {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  const SignupUser = (name, email, pass, e) => {
    e.preventDefault();
    var data = {
      name: name,
      email: email,
      password: pass,
    };
    axios.post("http://localhost:5000/user/add", data).then((user) => {
      if (user.data.msg === "user Added!") {
        Cookies.set("uid", user.data.details._id);
        alert(user.data.msg);
      } else {
        alert(user.data.msg);
      }
    });
  };
  const SignupTeacher = (name, email, pass, identity, e) => {
    e.preventDefault();
    var data = {
      name: name,
      email: email,
      password: pass,
      identity: identity,
    };
    axios.post("http://localhost:5000/teacher/add", data).then((user) => {
      if (user.data.msg === "teacher Added!") {
        Cookies.set("uid", user.data.details._id);
        alert(user.data.msg);
      } else {
        alert(user.data.msg);
      }
    });
  };
  const LoginUser = (email, pass, e) => {
    e.preventDefault();
    var data = {
      email: email,
      password: pass,
    };
    axios.post("http://localhost:5000/user/login", data).then((user) => {
      if (user.data != "wrong password!") {
        Cookies.set("uid", user.data._id);
        if (user.data._id) {
          alert("logged in");
        } else alert("user does exists!");
      } else {
        alert("wrong password");
      }
    });
  };
  return (
    <>
      <div className={style.landing}>
        <Navbar setShowLogin={setShowLogin} />
        {showLogin && (
          <Login
            setShowLogin={setShowLogin}
            setShowSignup={setShowSignup}
            LoginUser={LoginUser}
          />
        )}
        {showSignup && (
          <Signup
            setShowLogin={setShowLogin}
            setShowSignup={setShowSignup}
            SignupUser={SignupUser}
          />
        )}
        <div className="flex">
          <div className={style.left}>
            <p className={style.heading}>
              UNLEASH YOUR MASTERMIND CAPACITY NOW
            </p>
            <p className={style.content}>
              Enrich yourself with a personalized selection of skills. Serving
              you the best hub of skills present around the world. Peep onto our
              courses.
            </p>
            <button className={style.btn}>
              <a href="/courses">Cources</a>
              <BsArrowRight className="text-3xl" />
            </button>
          </div>
          <div className={style.right}>
            <img
              className={style.landingimg}
              src={landingimg}
              alt="landing-img"
            />
          </div>
        </div>

        <div>
          <p className={`${style.heading2} pt-36`}>Why Us?</p>
        </div>

        <div className="flex justify-center gap-32 pt-16 px-28">
          <div className={style.ypic1}>
            <img
              src={UsImage1}
              alt="Doubt Sessions"
              className={style.UsImages}
            />
            <div className="w-[22vw]">
              <p className={style.UsContentHeaders}>Doubt Clearing Classes</p>
              <p className={style.UsContent}>
                Chat with educators, ask questions, answer live polls, and get
                your doubts cleared. Request a 1-1 voice call or video chat.
              </p>
            </div>
          </div>
          <div className={style.ypic1}>
            <img
              src={UsImage2}
              alt="Doubt Sessions"
              className={style.UsImages}
            />
            <div className="w-[25vw]">
              <p className={style.UsContentHeaders}>DIY Course</p>
              <p className={style.UsContent}>
                Customize your course. Handpick your educators topic wise. Get
                your course with shuffled educators.
              </p>
            </div>
          </div>
          <div className={style.ypic1}>
            <img
              src={UsImage3}
              alt="Doubt Sessions"
              className={style.UsImages}
            />
            <div className="w-[25vw]">
              <p className={style.UsContentHeaders}>Downloadable lectures</p>
              <p className={style.UsContent}>
                Internet is a distraction can no more be an excuse, save your
                lectures on your portal when online and later enjoy them
                offline.
              </p>
            </div>
          </div>
        </div>

        <div className={style.UsBg}>
          <div>
            <div className="flex pt-72 ">
              <div>
                <p className={`${style.blob1Content} pb-28 pl-12`}>
                  Grab your popcorn and your notes, the new era of chilling
                  along with Education is here. Edflix is an online education
                  platform which is all you need to boost up your game of
                  knowledge. Gone are those days when you had to run to your
                  tuition centres, now invite them at your place. Learn
                  anywhere, anytime.
                </p>
              </div>

              <div className="pl-96 pt-8">
                <div className={`${style.blob1Logo}`}>
                  <p className="text-[#1A3168]">
                    <span className="text-[#FFF856]">ED</span>flix.
                  </p>
                </div>
                <img
                  src={blobImage1}
                  alt="Work"
                  className={`${style.blobImage1} -mt-44 pl-10`}
                />
              </div>
            </div>

            <div className="flex justify-between">
              <div>
                <img
                  src={blobImage2}
                  alt="Scroll"
                  className={`${style.blobImage2} pl-12 -mt-20`}
                />
              </div>
              <div>
                <p
                  className={`${style.blobImage1Content1} w-[20vw] mr-96 mt-28 `}
                >
                  Let us flex some love we get for EDFLIX.
                  <p className={`${style.blobImage1Content2}`}>
                    Hope to see your name soon there. Until then, keep learning!
                  </p>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={`${style.FooterBg} `}>
          <div>
            <p className={`${style.FooterTxt} pt-96 pl-12`}>Contact Us</p>
          </div>
          <div className={`${style.ContactDetails} pt-4 pl-12`}>
            <p>Email:xyz@gmail.com</p>
            <p>Phone No: 9855637343</p>
          </div>
          <div>
            <div className={`${style.FooterLogo} pt-4 pl-12`}>
              <p className="text-[#1A3168]">
                <span className="text-[#FFF856]">ED</span>flix.
              </p>
              <p className={`${style.FooterLogoCaption} -mt-6 `}>
                Crafted with love
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Landingpage;
